import React, { useMemo } from 'react';
import { useRouter } from 'next/router';

import { FLAT_TYPE_GENERIC } from '../../common/consts';
import { SearchOption } from '../../common/helpers/searchOption.utils';
import useCountyCityZone from '../../common/hooks/useCountyCityZone';
import { IMapArea } from '../../common/model/mapArea.model';
import { FlatType, flatTypeDict } from '../../common/model/enums/flatType.enum';

import { FlatBreadcrumb } from '../shared';

type Props = {
  searchOptions: SearchOption[];
  mapArea?: IMapArea;
};

const SearchBreadcrumb: React.FC<Props> = ({ searchOptions, mapArea }) => {
  const router = useRouter();

  const flatType = useMemo(() => {
    if (!router.query.flatType || router.query.flatType === FLAT_TYPE_GENERIC) {
      return flatTypeDict[FlatType.PISO].plural;
    }

    return router.query.flatType as string;
  }, [router.query.flatType]);

  const [county, city, zone] = useCountyCityZone();

  return (
    <div>
      <FlatBreadcrumb
        searchOptions={searchOptions}
        mapArea={mapArea}
        county={county}
        city={city}
        zone={zone}
        flatType={flatType}
      />
    </div>
  );
};

export default SearchBreadcrumb;
